import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { AvCheckbox, AvCheckboxGroup, AvForm } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import classNames from "classnames";

import formsValidators, {
  requiredIfOtherExist,
} from "../../validators/form.validators";
import useDropzoneFacade from "../../hooks/useDropzoneFacade";
import useAvForm from "../../hooks/useAvForm";
import FormGroupText from "./inputs/FormGroupText";
import WYSISYGComponent from "./inputs/WYSISYGComponent";
import FormGroupReactSelect from "./inputs/FormGroupReactSelect";
import noop from "../../helpers/noop";
import { getConverterKitTags } from "../../store/dashboard/ConverterKitTags/actions";
import useMountedState from "../../hooks/useMountedState";
import FormGroupVideo from "./inputs/FormGroupVideo";
import InputWithReadOnlyTextPart from "./inputs/InputWithReadOnlyTextPart";
import useInputWithReadOnlyTextPart from "../../hooks/useInputWithReadOnlyTextPart";
import useAutoPopulateAboutTutor from "../../hooks/useAutoPopulateAboutTutor";
import getReadOnlyUrlPart from "../../helpers/getReadOnlyUrlPart";

import styles from "./forms.module.scss";
import { COURSES_TYPES, PROVIDE_FREE_COURSE_TO_RADIO } from '../../constants/courses';
import FormGroupImages from './inputs/FormGroupImages';
import { getFileTags } from '../../store/dashboard/FileTags/actions';
import { getVideoLibraryForCourseOption, getVideoLibraryForCourseOptionClear, getTutorsForCourseOption, getTutorsForCourseOptionClear } from '../../store/dashboard/Courses/actions';
import { VIDEOS_LIST_LIMIT } from '../../constants/paginationConstants';
import FormGroupMultiSelect from './inputs/FormGroupMultiSelect';
import { VALUE_FIELD_ID } from '../../constants/selectConstants';
import { MAX_TAG_LENGTH } from '../../constants/leghtValidity';

const currencies = ["EUR", "USD", "GBP", "NZD", "AUD", "CAD", "INR"];
const applicableToSubscriptionValue = 'ApplicableToSubscription';
const collaborationCourseValue = 'CollaborationCourse';
const freeCourseValue = 'FreeCourse';


const studentLabels = ["Student 1", "Student 2", "Student 3"];

const SaveCourse = ({
  model,
  saveCourseFunc,
  converterKitTags,
  getConverterKitTags,
  courses,
  updateDirtyState = noop,
  categoryId,
  getFileTags,
  fileTags,
  getVideoLibraryForCourseOption,
  getVideoLibraryForCourseOptionClear,
  getTutorsForCourseOption,
  getTutorsForCourseOptionClear,
}) => {
  
  const initialState = {
    title: "",
    urlPart: "",
    numberOfReviews: "",
    overallRating: "",
    courseLengthInHours: "",
    overview: "",
    metaDescription: "",
    lessons: "",
    equipment: "",
    included: "",
    aboutTutor: "",
    tutorId: "",
    convertkitTagId: "",
    type: "",
    applicableToSubscription: [applicableToSubscriptionValue],
    collaborationCourse: [],
    EUR: "",
    USD: "",
    GBP: "",
    NZD: "",
    AUD: "",
    CAD: "",
    INR: "",
    overviewVideo: "",
    freeCourse: [],
  };

  const [formData, updateFormData] = useState(initialState);
  const [provideFreeCourseTo, setProvideFreeCourseTo] = useState("");
  const [isProvideFreeCourseToChanged, setIsProvideFreeCourseToChanged] = useState(false);
  
  const [tagId, setTagId] = useMountedState(null);
  const [courseType, setCourseType] = useMountedState(null);
  const [initialFile, updateInitialFile] = useMountedState(null);
  const [initialVideoThumbnail, updateInitialVideoThumbnail] =
    useMountedState(null);

  const [courseThumbnailImageInitialFile, updateCourseThumbnailImageInitialFile] = useMountedState(null);

  // Student image states for each student
  const [student0ImageInitialFile, updateStudent0ImageInitialFile] = useMountedState(null);
  const [student1ImageInitialFile, updateStudent1ImageInitialFile] = useMountedState(null);
  const [student2ImageInitialFile, updateStudent2ImageInitialFile] = useMountedState(null);

  const [ready, updateReadyState] = useMountedState(false);
  const [formRef, hasFormError, handleFormChange, isDirty, values] =
    useAvForm();

  const { data: fileTagsData } = fileTags;
  const { dataTutorsForCourseOption: tutorsData, loadingForTutorsForCourseOption: tutorsLoading } = courses;

  const [error, selectedFiles, handleAcceptedFiles, setSelectedFiles] =
    useDropzoneFacade({ type: "video" });

  const [
    thumbnailError,
    selectedThumbnailImages,
    handleTumbunalAcceptedFiles,
    setSelectedThumbnailImages,
    errorSelectedId,
  ] = useDropzoneFacade();

  const [
    courseThumbnailImageError,
    courseThumbnailImageSelectedFiles,
    courseThumbnailImageHandleAcceptedFiles,
    setCourseThumbnailImageSelectedFiles,
  ] = useDropzoneFacade();

  // Student image dropzone facades for each student
  const [
    student0ImageError,
    student0ImageSelectedFiles,
    student0ImageHandleAcceptedFiles,
    setStudent0ImageSelectedFiles,
  ] = useDropzoneFacade();

  const [
    student1ImageError,
    student1ImageSelectedFiles,
    student1ImageHandleAcceptedFiles,
    setStudent1ImageSelectedFiles,
  ] = useDropzoneFacade();

  const [
    student2ImageError,
    student2ImageSelectedFiles,
    student2ImageHandleAcceptedFiles,
    setStudent2ImageSelectedFiles,
  ] = useDropzoneFacade();

  const urlPart = useInputWithReadOnlyTextPart(
    values?.title,
    formRef,
    model?.urlPart
  );

  // Auto-populate aboutTutor when tutor is selected
  const aboutTutor = useAutoPopulateAboutTutor(
    formData?.tutorId?.[0], // Get the selected tutor ID from array
    tutorsData,
    model?.aboutTutor
  );

  const { loading, dataVideoLibraryForCourseOption: videoLibraryData } = courses;
  const { data } = converterKitTags;

  const courseTypeData = useMemo(() => {
    return Object.values(COURSES_TYPES).map((type) => ({
      id: type,
      name: type,
    }));
  }, []);

  const changeProvideFreeCourseToHandler = useCallback(
    (event) => {
      
      setProvideFreeCourseTo(event.target.value);
      handleFormChange();
      setIsProvideFreeCourseToChanged(true);
    },
    [handleFormChange]
  );

  const handleFormSubmit = (event, values) => {
    const {
      title,
      urlPart,
      numberOfReviews,
      overallRating,
      courseLengthInHours,
      overview,
      metaDescription,
      lessons,
      equipment,
      included,
      aboutTutor,
      tutorId,
      convertkitTagId,
      feedback0,
      author0,
      studentRating0,
      studentImageFileId0,
      feedback1,
      author1,
      studentRating1,
      studentImageFileId1,
      feedback2,
      author2,
      studentRating2,
      studentImageFileId2,
      applicableToSubscription,
      collaborationCourse,
      type,
      freeCourse,
    } = values;
    const model = {
      title,
      urlPart,
      numberOfReviews,
      overallRating,
      courseLengthInHours,
      overview,
      metaDescription,
      lessons,
      equipment,
      included,
      aboutTutor,
      tutorId: tutorId[0],
      convertkitTagId,
      type: Array.isArray(type) ? null : type, // when no value is selected then type is an array and we set it to null
      isApplicableToSubscription: applicableToSubscription.length === 1,
      isCollaborationCourse: collaborationCourse.length === 1,
      isFreeCourse: freeCourse.length === 1,
      provideFreeCourseTo: provideFreeCourseTo ? provideFreeCourseTo : null,
      fileId: formData.overviewVideo[0],
      prices: currencies.map((currency) => ({
        currency,
        price: Number(values[currency]),
      })),

    };
    if (feedback0 || feedback1 || feedback2 || author0 || author1 || author2 || studentRating0 || studentRating1 || studentRating2) {
      model.studentsSays = [];

      feedback0 &&
        model.studentsSays.push({ feedback: feedback0, author: author0, studentRating: studentRating0, fileId: studentImageFileId0 || null });
      feedback1 &&
        model.studentsSays.push({ feedback: feedback1, author: author1, studentRating: studentRating1, fileId: studentImageFileId1 || null });
      feedback2 &&
        model.studentsSays.push({ feedback: feedback2, author: author2, studentRating: studentRating2, fileId: studentImageFileId2 || null });
    }
    if (initialFile !== selectedFiles[0]) {
      model.files = selectedFiles;
    }

    if (formData.newVideoTagscourse_0 && formData.newVideoTagscourse_0.length) {
      model.tags = formData.newVideoTagscourse_0;
    }
    

    if (initialVideoThumbnail !== selectedThumbnailImages[0]) {
      model.videoThumbnail = selectedThumbnailImages;
    }

    if (courseThumbnailImageInitialFile !== courseThumbnailImageSelectedFiles[0]) {
      model.courseThumbnailImage = courseThumbnailImageSelectedFiles;
    }

    // Add student images to model
    if (student0ImageInitialFile !== student0ImageSelectedFiles[0]) {
      model.student0Image = student0ImageSelectedFiles;
    }
    if (student1ImageInitialFile !== student1ImageSelectedFiles[0]) {
      model.student1Image = student1ImageSelectedFiles;
    }
    if (student2ImageInitialFile !== student2ImageSelectedFiles[0]) {
      model.student2Image = student2ImageSelectedFiles;
    }

    saveCourseFunc(model);
  };

  const pageTitle = useMemo(
    () => (model ? "Edit course" : "Create course"),
    [model]
  );
  const btnSaveLabel = useMemo(
    () => (model ? "Save" : "Create draft"),
    [model]
  );



  const disableState = useMemo(
    () =>
      !(
        isDirty ||
        initialFile !== selectedFiles[0] ||
        initialVideoThumbnail !== selectedThumbnailImages[0] ||
        courseThumbnailImageInitialFile !== courseThumbnailImageSelectedFiles[0] ||
        student0ImageInitialFile !== student0ImageSelectedFiles[0] ||
        student1ImageInitialFile !== student1ImageSelectedFiles[0] ||
        student2ImageInitialFile !== student2ImageSelectedFiles[0] ||
        tagId !== model?.convertkitTagId ||
        courseType !== model?.type ||
        isProvideFreeCourseToChanged

      ) ||
      loading ||
      //if overview video is selected from select dropdown then do not check for selectedFiles and selectedThumbnailImages
      (!selectedFiles.length && !Array.isArray(formData.overviewVideo)) ||
      (!selectedThumbnailImages[0] && !Array.isArray(formData.overviewVideo)) ||
      hasFormError,
    [
      loading,
      selectedFiles,
      selectedThumbnailImages,
      courseThumbnailImageSelectedFiles,
      hasFormError,
      isDirty,
      initialFile,
      initialVideoThumbnail,
      courseThumbnailImageInitialFile,
      tagId,
      model,
      courseType,
      isProvideFreeCourseToChanged,
    ]
  );

  useEffect(() => {
    getConverterKitTags();
    getTutorsForCourseOption({});
  }, []);

  useEffect(() => {
    updateDirtyState(isDirty);
  }, [isDirty]);

  useEffect(() => {
    if (!!model) {
      const {
        title,
        numberOfReviews,
        overallRating,
        courseLengthInHours,
        overview,
        metaDescription,
        lessons,
        equipment,
        included,
        aboutTutor,
        // tutorId,
        convertkitTagId,
        type,
        prices,
        studentsSays,
        initialFile,
        courseThumbnailImageInitialFile,
        isApplicableToSubscription,
        isCollaborationCourse,
        isFreeCourse,
        provideFreeCourseTo,
        video,
      } = model;
      const formData = {
        ...initialState,
        title,
        numberOfReviews: numberOfReviews || "",
        overallRating: overallRating || "",
        courseLengthInHours: courseLengthInHours || "",
        overview,
        metaDescription,
        lessons,
        equipment,
        included,
        aboutTutor,
        // tutorId,
        convertkitTagId,
        type,
        applicableToSubscription: isApplicableToSubscription ? [applicableToSubscriptionValue] : [],
        collaborationCourse: isCollaborationCourse ? [collaborationCourseValue] : [],
        freeCourse: isFreeCourse ? [freeCourseValue] : [],
        video: [video.id],
      };

      if (prices) {
        prices.forEach(
          ({ currency, price }) => (formData[currency] = String(price))
        );
      }

      if (studentsSays) {
        studentsSays.forEach(({ author, feedback, studentRating, fileId }, index) => {
          formData["author" + index] = author;
          formData["feedback" + index] = feedback;
          formData["studentRating" + index] = studentRating;
          formData["studentImageFileId" + index] = fileId || "";
        });
      }

      if (initialFile) {
        updateInitialFile(initialFile);
        handleAcceptedFiles([initialFile], []);
      }

      if (initialFile?.thumbnailImage) {
        updateInitialVideoThumbnail(initialFile.thumbnailImage);
        handleTumbunalAcceptedFiles([initialFile.thumbnailImage], []);
      }

      if (courseThumbnailImageInitialFile) {
        updateCourseThumbnailImageInitialFile(courseThumbnailImageInitialFile);
        courseThumbnailImageHandleAcceptedFiles([courseThumbnailImageInitialFile], []);
      }

      // Handle student images from model
      if (model.student0ImageInitialFile) {
        updateStudent0ImageInitialFile(model.student0ImageInitialFile);
        student0ImageHandleAcceptedFiles([model.student0ImageInitialFile], []);
      }
      if (model.student1ImageInitialFile) {
        updateStudent1ImageInitialFile(model.student1ImageInitialFile);
        student1ImageHandleAcceptedFiles([model.student1ImageInitialFile], []);
      }
      if (model.student2ImageInitialFile) {
        updateStudent2ImageInitialFile(model.student2ImageInitialFile);
        student2ImageHandleAcceptedFiles([model.student2ImageInitialFile], []);
      }

      setTagId(convertkitTagId);
      setCourseType(type);

      updateFormData(formData);
      setProvideFreeCourseTo(provideFreeCourseTo);
    }

    updateReadyState(true);
  }, [model]);

  useEffect(() => {
    if (ready && selectedFiles.length === 0 && initialFile) {
      setSelectedFiles([initialFile]);
    }
  }, [selectedFiles]);

  useEffect(() => {
    if (ready && courseThumbnailImageSelectedFiles.length === 0 && courseThumbnailImageInitialFile) {
      setCourseThumbnailImageSelectedFiles([courseThumbnailImageInitialFile]);
    }
  }, [courseThumbnailImageSelectedFiles]);

  useEffect(() => {
    if (ready && student0ImageSelectedFiles.length === 0 && student0ImageInitialFile) {
      setStudent0ImageSelectedFiles([student0ImageInitialFile]);
    }
  }, [student0ImageSelectedFiles]);

  useEffect(() => {
    if (ready && student1ImageSelectedFiles.length === 0 && student1ImageInitialFile) {
      setStudent1ImageSelectedFiles([student1ImageInitialFile]);
    }
  }, [student1ImageSelectedFiles]);

  useEffect(() => {
    if (ready && student2ImageSelectedFiles.length === 0 && student2ImageInitialFile) {
      setStudent2ImageSelectedFiles([student2ImageInitialFile]);
    }
  }, [student2ImageSelectedFiles]);


  const tagIdValue = useMemo(() => {
    if (data && tagId) {
      return data.find(({ id }) => id === tagId);
    }
  }, [data, tagId]);

  const courseTypeValue = useMemo(() => {
    if (courseTypeData && courseType) {
      return courseTypeData.find(({ id }) => id === courseType);
    }
  }
  , [courseTypeData, courseType]);

  useEffect(() => {
    getFileTags();
  }, []);

  const getVideoLibraryOptions = (inputValue) => {
    // if (!inputValue || inputValue.length < 3) {
    //   if (videoLibraryData.length > 0) {
    //     getVideoLibraryForCourseOptionClear();
    //   }
    // }

    getVideoLibraryForCourseOption({ q: inputValue, limit: VIDEOS_LIST_LIMIT, offset: 0 });
  }

  const getOverviewVideoValue = useMemo(() => {
    if (!!model) {
      return {
          id: model.video.id,
          name: `${model.video.id} | ${model.video.title || '-'}`,
        }
      // return model.video.map(({ id, title }) => {
      //   return {
      //     id: id,
      //     name: `${id} | ${title}`,
      //   }
      // });
    }
  }, [model]);

  const getTutorValue = useMemo(() => {
    if (!!model) {
      return {
          id: model.tutor.id,
          name: model.tutor.name,
        }
    }
  }, [model]);

  return (
    ready && (
      <>
        <AvForm
          onValidSubmit={handleFormSubmit}
          ref={formRef}
          model={formData}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              return false;
            }
          }}
        >
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{pageTitle}</CardTitle>
              <FormGroupText
                name="title"
                label="Course title"
                placeholder="Enter course title"
                validator={formsValidators.course.title}
                handleFormChange={handleFormChange}
              />
              <InputWithReadOnlyTextPart
                name="urlPart"
                label="Course URL"
                readOnlyPart={getReadOnlyUrlPart("online-dj-courses")}
                validator={formsValidators.course.urlPart}
                handleFormChange={handleFormChange}
                value={urlPart}
              />
              <FormGroupText
                name="metaDescription"
                label="Meta Description"
                placeholder="Enter meta description"
                validator={formsValidators.course.metaDescription}
                handleFormChange={handleFormChange}
              />
              <FormGroupReactSelect
                options={courseTypeData}
                name="type"
                label="Course Type"
                value={courseTypeValue}
                getValue={(value) => setCourseType(value)}
                placeholder="Choose course type"
                // validator={formsValidators.course.convertkitTagId}
                handleFormChange={handleFormChange}
              />
              <FormGroupImages
                multiple={false}
                label="Course Thumbnail"
                error={courseThumbnailImageError}
                selectedImages={courseThumbnailImageSelectedFiles}
                initialFile={courseThumbnailImageInitialFile}
                handleAcceptedImages={courseThumbnailImageHandleAcceptedFiles}
                setSelectedImages={setCourseThumbnailImageSelectedFiles}
             />
              {/* 
                  <FormGroupVideo
                  withThumbnail
                  withTag
                  multiple={false}
                  label="Overview video"
                  error={error} // Dropzone
                  initialFile={initialFile} // State
                  initialVideoThumbnail={initialVideoThumbnail} // State
                  updateInitialVideoThumbnail={updateInitialVideoThumbnail} // State
                  selectedVideos={selectedFiles} //Dropzone
                  handleAcceptedVideos={handleAcceptedFiles} //Dropzone
                  setSelectedVideos={setSelectedFiles} //Dropzone
                  thumbnailError={thumbnailError} //Dropzone Thumbnail
                  selectedThumbnailImages={selectedThumbnailImages} //Dropzone Thumbnail
                  handleTumbunalAcceptedFiles={handleTumbunalAcceptedFiles} //Dropzone Thumbnail
                  setSelectedThumbnailImages={setSelectedThumbnailImages} //Dropzone Thumbnail
                  errorIndex={errorSelectedId} //Dropzone Thumbnail
                  updateFormData={updateFormData}
                  handleFormChange={handleFormChange}
                  fileTagsData={fileTagsData}
                  groupIdentifier={'course'}
                />
              */}
              
              <FormGroupMultiSelect
                name="overviewVideo"
                allowCreate={false}
                label="Overview video"
                placeholder="Choose Overview video from video library"
                value={getOverviewVideoValue}
                options={videoLibraryData.map(({ id, title }) => ({
                  id: id,
                  name: `${id} | ${title || '-'}`,
                }))}
                validator={formsValidators.course.overviewVideoId}
                handleFormChange={handleFormChange}
                formState={formData}
                updateFormState={updateFormData}
                maxCreateLength={MAX_TAG_LENGTH}
                isMulti={false}
                optionValueName={VALUE_FIELD_ID}
                loadOptions={getVideoLibraryOptions}
                styles={{
                  // Fixes the overlapping problem of the component
                  menu: provided => ({ ...provided, zIndex: 9999 })
                }}
            />

               {/* <FormGroupAsyncReactSelect
                // options={data}
                loadOptions={getVideoLibraryOptions}
                name="convertkitTagId"
                label="Or Select from Video Library"
                value={tagIdValue}
                getValue={(value) => setTagId(value)}
                placeholder="Choose Overview video from video library"
                validator={formsValidators.course.convertkitTagId}
                handleFormChange={handleFormChange}
              /> */}
              <CardTitle className="mb-4">Course info</CardTitle>
              <FormGroupText
                name={"numberOfReviews"}
                label={'Number of reviews'}
                placeholder={`Enter Number of reviews`}
                validator={formsValidators.course.numberOfReviews}
                handleFormChange={handleFormChange}
              />
              <FormGroupText
                name={"overallRating"}
                label={'Overall Rating'}
                placeholder={`Enter Overall Rating`}
                validator={formsValidators.course.overallRating}
                handleFormChange={handleFormChange}
              />
              <FormGroupText
                name={"courseLengthInHours"}
                label={'Course length (in hours)'}
                placeholder={`Enter Course length (in hours)`}
                validator={formsValidators.course.courseLengthInHours}
                handleFormChange={handleFormChange}
              />
              <WYSISYGComponent
                name="overview"
                label="Overview"
                validator={formsValidators.course.overview}
                handleFormChange={handleFormChange}
              />
              <WYSISYGComponent
                name="lessons"
                label="Lessons"
                validator={formsValidators.course.lessons}
                handleFormChange={handleFormChange}
              />
              <WYSISYGComponent
                name="included"
                label="What’s included?"
                placeholder="Enter what's included"
                validator={formsValidators.course.included}
                handleFormChange={handleFormChange}
              />
              <FormGroup className='mb-4' row>
              <Col lg={2}>
               <Label>Subscription Preference</Label>
              </Col>
              <Col lg={10}>
              <AvCheckboxGroup className='' name={'applicableToSubscription'}>
                <AvCheckbox
                  onChange={handleFormChange}
                  className="cursor-pointer"
                  customInput
                  label="Applicable to Subscription"
                  value={applicableToSubscriptionValue}
                />
                </AvCheckboxGroup>
              </Col>
              
              </FormGroup>

              <FormGroup className='mb-4' row>
              <Col lg={2}>
               <Label>Is Collaboration Course</Label>
              </Col>
              <Col lg={10}>
              <AvCheckboxGroup className='' name={'collaborationCourse'}>
                <AvCheckbox
                  disabled={!!model}
                  onChange={handleFormChange}
                  className="cursor-pointer"
                  customInput
                  label="Is Collaboration Course"
                  value={collaborationCourseValue}
                />
                </AvCheckboxGroup>
              </Col>
              
              </FormGroup>

              <FormGroup className='mb-4' row>
              <Col lg={2}>
               <Label>Is Free Course</Label>
              </Col>
              <Col lg={10}>
              <AvCheckboxGroup className='' name={'freeCourse'}>
                <AvCheckbox
                  disabled={!!model && model.isFreeCourse}
                  onChange={handleFormChange}
                  className="cursor-pointer"
                  customInput
                  label="Is Free Course"
                  value={freeCourseValue}
                />
                </AvCheckboxGroup>
              </Col>
              
              </FormGroup>
              <FormGroup className="custom-control custom-radio mt-4 mb-3 d-flex pl-0" row>
              <Col lg={2}>
                <Label>Provide Free Course To</Label>
              </Col>
              <Col lg={10} className='d-flex flex-row pl-5'>
                {PROVIDE_FREE_COURSE_TO_RADIO.map(({ label, value }, index) => (
                  <FormGroup
                    className={classNames(
                      "mb-0",
                      index !== PROVIDE_FREE_COURSE_TO_RADIO.length - 1 && "mr-5"
                    )}
                    key={`provide-free-course-to-radio-${index}`}
                  >
                    <Input
                      disabled={!!model && model.isFreeCourse}
                      type="radio"
                      id={`provide-free-course-to-radio-${index}`}
                      name="provideFreeCourseTo"
                      className="custom-control-input"
                      onChange={changeProvideFreeCourseToHandler}
                      value={value}
                      checked={provideFreeCourseTo === value}
                    />
                    <Label
                      className="custom-control-label"
                      htmlFor={`provide-free-course-to-radio-${index}`}
                    >
                      {label}
                    </Label>
                  </FormGroup>
                ))}
              
              </Col>
              
            </FormGroup>
              
              <WYSISYGComponent
                name="equipment"
                label="Equipment"
                validator={formsValidators.course.equipment}
                handleFormChange={handleFormChange}
              />
              <FormGroupMultiSelect
                name="tutorId"
                allowCreate={false}
                label="Tutor"
                placeholder="Select tutor"
                value={getTutorValue}
                options={tutorsData?.map(({ id, name }) => ({
                  id: id,
                  name: name,
                })) || []}
                validator={formsValidators.course.tutor}
                handleFormChange={handleFormChange}
                formState={formData}
                updateFormState={updateFormData}
                isMulti={false}
                optionValueName={VALUE_FIELD_ID}
                loading={tutorsLoading}
              />
              <FormGroupText
                name="aboutTutor"
                label="About the tutor"
                placeholder="Enter about the tutor"
                validator={formsValidators.course.aboutTutor}
                handleFormChange={handleFormChange}
                value={aboutTutor}
              />
              <CardTitle className="mb-4">Prices</CardTitle>
              {currencies.map((currency, index) => (
                <Fragment key={"currency-" + index}>
                  <FormGroupText
                    name={currency}
                    label={currency}
                    placeholder={`Enter ${currency}`}
                    validator={formsValidators.course.prices}
                    handleFormChange={handleFormChange}
                  />
                </Fragment>
              ))}
              <CardTitle className="mb-4">Add ConvertKit tag</CardTitle>
              <FormGroupReactSelect
                options={data}
                name="convertkitTagId"
                label="Tag"
                value={tagIdValue}
                getValue={(value) => setTagId(value)}
                placeholder="Choose tag"
                validator={formsValidators.course.convertkitTagId}
                handleFormChange={handleFormChange}
              />
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">What our students say</CardTitle>
              {studentLabels.map((title, sectionIndex) => (
                <Fragment key={"feedback" + sectionIndex}>
                  <CardTitle className="mb-4">{title}</CardTitle>
                  <FormGroupText
                    name={"feedback" + sectionIndex}
                    label="Feedback"
                    placeholder="Enter feedback"
                    validator={{
                      requiredIfOtherExist: requiredIfOtherExist(
                        "author" + sectionIndex,
                        "“Feedback” field is required"
                      ),
                      ...formsValidators.course.feedback,
                    }}
                    handleFormChange={handleFormChange}
                  />
                  <FormGroupText
                    name={"author" + sectionIndex}
                    label="Author"
                    placeholder="Enter author"
                    validator={{
                      requiredIfOtherExist: requiredIfOtherExist(
                        "feedback" + sectionIndex,
                        "“Author” field is required"
                      ),
                      ...formsValidators.course.author,
                    }}
                    handleFormChange={handleFormChange}
                  />
                  <FormGroupText
                    name={"studentRating" + sectionIndex}
                    label={'Student Rating'}
                    placeholder={`Enter Student Rating`}
                    validator={{
                      requiredIfOtherExist: requiredIfOtherExist(
                        "author" + sectionIndex,
                        "“Student Rating” field is required"
                      ),
                      ...formsValidators.course.studentRating,
                    }}
                    handleFormChange={handleFormChange}
                  />
                  <FormGroupText
                    type='hidden'
                    name={"studentImageFileId" + sectionIndex}
                    label={''}
                    placeholder={`Enter Student Image File ID`}
                    handleFormChange={handleFormChange}
                  />
                  <FormGroupImages
                    multiple={false}
                    label={`${title} Image`}
                    error={sectionIndex === 0 ? student0ImageError : sectionIndex === 1 ? student1ImageError : student2ImageError}
                    selectedImages={sectionIndex === 0 ? student0ImageSelectedFiles : sectionIndex === 1 ? student1ImageSelectedFiles : student2ImageSelectedFiles}
                    initialFile={sectionIndex === 0 ? student0ImageInitialFile : sectionIndex === 1 ? student1ImageInitialFile : student2ImageInitialFile}
                    handleAcceptedImages={sectionIndex === 0 ? student0ImageHandleAcceptedFiles : sectionIndex === 1 ? student1ImageHandleAcceptedFiles : student2ImageHandleAcceptedFiles}
                    setSelectedImages={sectionIndex === 0 ? setStudent0ImageSelectedFiles : sectionIndex === 1 ? setStudent1ImageSelectedFiles : setStudent2ImageSelectedFiles}
                  />
                </Fragment>
              ))}
            </CardBody>
          </Card>
          <Row className="justify-content-end">
            <Col xs="12">
              <Link
                to={`/training/${
                  !!model ? model.courseCategoryId : categoryId
                }`}
              >
                <Button color="secondary" className="mr-2">
                  Cancel
                </Button>
              </Link>
              <Button
                type="submit"
                color="primary"
                disabled={disableState}
                className={styles.btnSave}
              >
                {btnSaveLabel}
              </Button>
            </Col>
          </Row>
        </AvForm>
      </>
    )
  );
};

const mapStateToProps = ({ Courses, ConverterKitTags, FileTags }) => {
  return {
    converterKitTags: ConverterKitTags,
    courses: Courses,
    fileTags: FileTags,
  };
};

export default connect(mapStateToProps, { 
  getConverterKitTags, 
  getFileTags, 
  getVideoLibraryForCourseOption, 
  getVideoLibraryForCourseOptionClear,
  getTutorsForCourseOption,
  getTutorsForCourseOptionClear
})(SaveCourse);
